import React from 'react';
import PropTypes from 'prop-types';
import PeriodTabsListing from './PeriodTabsListing';
import effectiveYearSpec from './effectiveYears';

/**
 * Builds a year-bar listing for a type whose date lives in `effective`.
 *
 * The counterpart of `createCardListingView`, and takes the same options for
 * the same reasons: News and People bring their own fixed grid, some listings
 * never linked to the full view. News, talks and videos differ only in the
 * card they draw, so each is this factory with a card passed in.
 */
const createYearTabsListingView = (
  CardComponent,
  {
    displayName,
    containerClass = '',
    supportsGrid = true,
    hideLinkByDefault = false,
  } = {},
) => {
  const View = (props) => {
    const useGrid = supportsGrid && props.grid_layout;
    return (
      <PeriodTabsListing
        {...props}
        spec={effectiveYearSpec}
        card={CardComponent}
        containerClass={containerClass}
        cardProps={{
          compact: props.compact,
          hideLink: props.hide_link ?? hideLinkByDefault,
          gridLayout: useGrid,
        }}
      />
    );
  };
  View.displayName = displayName || 'YearTabsListingView';
  View.propTypes = {
    compact: PropTypes.bool,
    hide_link: PropTypes.bool,
    grid_layout: PropTypes.bool,
  };
  return View;
};

export default createYearTabsListingView;
